import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export const AnnualBankRevenueProcessPayloadSchema = z.object({
    annualBankRevenue: z.number().optional(),
    currency: EnumSchema(Currency).optional(),
});

export class AnnualBankRevenueProcessPayload extends FromSchema(AnnualBankRevenueProcessPayloadSchema) {
    annualBankRevenue?: number;
    currency?: Currency;
}
